import React, { useEffect, useMemo, useState } from 'react'
import {IntlProvider} from 'react-intl'
import useLocale from './Hook/locale';
import DEFAULT_MESSAGES from './i18n/defaults';

function LanguageProvider({children}:any) {
  const locale = useLocale();

  /**
   * Translations come from the platform, so an id it has not shipped yet would render
   * as the id itself. The English defaults sit underneath and only ever fill a hole —
   * anything the platform sends wins.
   */
  const messages = useMemo(
    () => ({ ...DEFAULT_MESSAGES, ...(locale.translation ?? {}) }),
    [locale.translation],
  );

  useEffect(() => {
    locale.changeLang(localStorage.getItem("lang") ?? navigator.language.split("-")[0]);
  }, []);
  
  return (
    <IntlProvider messages={messages} locale={locale.locale} defaultLocale="en"
      defaultRichTextElements={{ 
        b: (chunks) => <b>{chunks}</b>,
        strong: (chunks) => <strong>{chunks}</strong>,
        span: (chunks) => <span>{chunks}</span>,
        br: () => <br />,
        p: (chunks) => <p>{chunks}</p>,
        u: (chunks) => <u>{chunks}</u>,
        i: (chunks) => <i>{chunks}</i>,
       }}
    >
      {children}
    </IntlProvider>
  )
}

export default LanguageProvider